export const SUCCESSFULLY_INITIALIZED = 'initialized-successfully'
export const FAILED_TO_INITIALIZE = 'failed-to-initialize'
